import React, { useState, useEffect } from "react";

import { Layout, Menu, Breadcrumb, Table, Tag, Space, DatePicker } from "antd";

function CollegueProfil({ collegueTab, poste }) {
  var photo =
    collegueTab[
      collegueTab.indexOf(
        collegueTab.find((element) => element.poste === poste)
      )
    ].photo_poste_interne === ""
      ? null
      : collegueTab[
          collegueTab.indexOf(
            collegueTab.find((element) => element.poste === poste)
          )
        ].lien_photo_poste_interne;
  var collegue =
    collegueTab[
      collegueTab.indexOf(
        collegueTab.find((element) => element.poste === poste)
      )
    ];

  return (
    <div>
      <div style={{ marginBottom: "40px" }}>
        <div style={{ display: "flex" }}>
          {photo !== null ? (
            <img className="h-24 w-24 rounded-full mr-3" src={photo} />
          ) : (
            <svg
              className="h-24 w-24 rounded-full mr-3 text-gray-400"
              fill="currentColor"
              viewBox="0 0 24 24"
            >
              <path d="M24 20.993V24H0v-2.996A14.977 14.977 0 0112.004 15c4.904 0 9.26 2.354 11.996 5.993zM16.002 8.999a4 4 0 11-8 0 4 4 0 018 0z"></path>
            </svg>
          )}
          <div style={{ margin: "auto 15px" }}>
            <div style={{ fontSize: "1.5rem", fontWeight: "700" }}>
              {collegue.nom}
            </div>
            <span>Poste: {poste}</span>
          </div>
        </div>
        <div style={{ marginTop: "1.25rem" }}>
          <button
            type="button"
            className="  w-48  items-center justify-center px-4 py-2 border border-transparent rounded-md shadow-sm text-sm font-medium text-white focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-green-500 sm:flex-1"
            style={{ backgroundColor: "rgb(6, 95, 70)" }}
          >
            Appeler
          </button>
        </div>
      </div>

      <div>
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            borderBottom: "1px solid #e9e9e9",
            padding: "15px",
          }}
        >
          <div style={{ fontWeight: "500" }}>Département</div>
          <div>{collegue.departement}</div>
        </div>

        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            borderBottom: "1px solid #e9e9e9",
            padding: "15px",
          }}
        >
          <div style={{ fontWeight: "500" }}>E-Mail</div>
          <div>{collegue.adresse_mail}</div>
        </div>

        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            borderBottom: "1px solid #e9e9e9",
            padding: "15px",
          }}
        >
          <div style={{ fontWeight: "500" }}>Adresse</div>
          <div>{collegue.adresse}</div>
        </div>

        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            borderBottom: "1px solid #e9e9e9",
            padding: "15px",
          }}
        >
          <div style={{ fontWeight: "500" }}>Poste</div>
          <div>{collegue.poste}</div>
        </div>

        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            borderBottom: "1px solid #e9e9e9",
            padding: "15px",
          }}
        >
          <div style={{ fontWeight: "500" }}>Mobile</div>
          <div>{collegue.collection.mobilephone.tel_mobil}</div>
        </div>
      </div>
    </div>
  );
}

export default CollegueProfil;
